import { adminHttpClient } from '../commons/adminHttpClient'

export type CompanyUserNotificationDateInfoRequest = {
  planPeriodId: string
  companyUserId?: string
  overrideBenefitEligibilityDate?: string
}

export type CompanyNotificationDateInfoResponse = {
  notificationDate?: string
  requireEmployeeNotificationDate: boolean
  isEmployeeNotificationDateEditable: boolean
  maxNotificationDate?: string
  minNotificationDate: string
}

const getCompanyUserNotificationDateInfo = (
  request: CompanyUserNotificationDateInfoRequest,
): Promise<CompanyNotificationDateInfoResponse> => {
  return adminHttpClient.get(`/Benefit/CompanyUserNotificationDateInfo`, request)
}

export default getCompanyUserNotificationDateInfo
